<template>
  <div class="property-input" :style="getStyleColor()" v-if="element" :class="{primary: isPrimary, softHidden: isExpanded == false, bordered: element.isBaseElement == false}">
    <div class="property-header">
      <div class="property-header-left">
        <label class="property-label">
          {{ element?.Name }}
        </label>
      </div>
      <!-- Bouton visible-->
      <button v-if="element.CanBeHide" class="short-button" title="Options" @click="updateProperty({element: element, property: {name: 'Show'}, value: !element.Show})">
        <svg xmlns="http://www.w3.org/2000/svg" class="short-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
          <line v-if="!element.Show" x1="1" y1="23" x2="23" y2="1" stroke-width="2"/>
        </svg>
      </button>
      <!-- Bouton options -->
      <button class="short-button" title="Options" v-if="hasOption" @click="showContextMenu">
        <optionIcon class="short-icon"/>
      </button>
      <!-- Bouton Expension -->
      <span class="property-toggle-icon" :class="{ 'expanded': isExpanded }" v-if="canExpand" @click="toggleExpanded">
        <expandeIcon/>
      </span>
    </div>

    <div class="property-content">
      <div class="property-content-simple">
        <div v-for="p in simpleElement" :key="p.name">
          <component :isComposition="isComposition" :is="p.type" :property="p" :element="element[p.name]" :container="element" />
        </div>
      </div>
      <div v-for="p in objectElement" :key="p.name">
        <component :isComposition="isComposition" v-if="element[p.name] !== null" :is="p.type" :property="p" :element="element[p.name]" :container="element" />
      </div>
    </div>

    <NameElementPopup v-if="element.CanChangeName" :show="showNameEdit" :defaultName="element.Name" @close="showNameEdit = false" @named="changeName"/>
    <DeleteConfirmPopup
      :show="showDeleteConfirm"
      :elementName="element.Name"
      @close="showDeleteConfirm = false"
      @confirm="confirmDelete"
    />
    <AddSubElementPopup
      :show="showAddSubElementPopup"
      :containerName="element.Name"
      :subElements="getSubElement()"
      @close="showAddSubElementPopup = false"
      @select="addSubElement"
    />
    <NameElementPopup 
      :show="shurtCutSelected?.type == 'textInput'"
      label="Text de l'élément"
      :defaultName="shurtCutSelected?.name ? element[shurtCutSelected?.name] : ''"
      @close="togglePopup"
      @named="updateValue"
    />
    <ResourceSelectionPopup
      :show="shurtCutSelected?.type == 'pathInput'"
      :ressourceType="shurtCutSelected?.ressourceType"
      :selectedResourcePath="element[shurtCutSelected?.name]"
      @close="togglePopup"
      @select="selectRessource"
    />
    <ColorPickerPopup 
      :show="shurtCutSelected?.type == 'colorInput'" 
      :color="element[shurtCutSelected?.name]"
      @close="togglePopup"
      @update="updateValue"
    />
    <context-menu v-model:show="contextMenuShow" :options="contextMenuComponent">
      <context-menu-item @click="showNameEdit = true" v-if="element.CanChangeName">
        <template #icon>
          <textIcon/>
        </template>
        <template #label>
          Modifier le nom
        </template>
      </context-menu-item>
      <context-menu-item v-if="canBeUpped" @click="changePosition(-1)">
        <template #icon>
          <upperIcon/>
        </template>
        <template #label>
          Monter
        </template>
      </context-menu-item>
      <context-menu-item v-if="canBeLowered" @click="changePosition(1)">
        <template #icon>
          <lowerIcon/>
        </template>
        <template #label>
          Descendre
        </template>
      </context-menu-item>
      <context-menu-item v-for="shortCut in element.shortCut" @click="selectShurtCut(shortCut)">
        <template #icon v-if="shortCut.svgComponentIcon">
          <component :is="shortCut.svgComponentIcon"></component>
        </template>
        <template #label>
          {{ shortCut.description }}
        </template>
      </context-menu-item>
      <context-menu-item v-if="canAddSubElement" @click="showAddSubElementPopup = true; contextMenuShow = false;">
        <template #icon>
          <addIcon/>
        </template>
        <template #label>
          Ajouter un élément
        </template>
      </context-menu-item>
      <context-menu-item v-if="element.CanBeRemove" @click="showDeleteConfirm = true; contextMenuShow = false;">
        <template #icon>
          <deleteIcon/>
        </template>
        <template #label>
          Supprimer l'élément
        </template>
      </context-menu-item>
    </context-menu>

  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as mutates from "../../vuexStore/mutations.js"
import * as actions from "../../vuexStore/actions.js"
import pageElements from "../../vuexStore/type/definition/pageElement.js"
import imageCarouselIcon from "../IconComponents/imageCarouselIcon.vue"
import optionIcon from "../IconComponents/optionIcon.vue"
import textIcon from "../IconComponents/textIcon.vue"
import colorIcon from "../IconComponents/colorIcon.vue"
import copyIcon from "../IconComponents/copyIcon.vue"
import upperIcon from "../IconComponents/upperIcon.vue"
import lowerIcon from "../IconComponents/lowerIcon.vue"
import addIcon from "../IconComponents/addIcon.vue"
import deleteIcon from "../IconComponents/deleteIcon.vue"
import expandeIcon from "../IconComponents/expandeIcon.vue"
import AddSubElementPopup from "../PopupComponents/AddSubElementPopup.vue"
import ResourceSelectionPopup from "../PopupComponents/ResourceSelectionPopup.vue"
import ColorPickerPopup from "../PopupComponents/ColorPickerPopup.vue"
import DeleteConfirmPopup from "../PopupComponents/DeleteConfirmPopup.vue"
import NameElementPopup from "../PopupComponents/NameElementPopup.vue"

export default {
  name: 'ObjectInput',
  components: {
    'colorInput': defineAsyncComponent(() => import('@/components/PropertyComponents/color.vue')),
    'numberInput': defineAsyncComponent(() => import('@/components/PropertyComponents/number.vue')),
    'booleanInput': defineAsyncComponent(() => import('@/components/PropertyComponents/boolean.vue')),
    'selectInput': defineAsyncComponent(() => import('@/components/PropertyComponents/select.vue')),
    'textInput': defineAsyncComponent(() => import('@/components/PropertyComponents/text.vue')),
    'pathInput': defineAsyncComponent(() => import('@/components/PropertyComponents/path.vue')),
    'arrayInput': defineAsyncComponent(() => import('@/components/PropertyComponents/array.vue')),
    'rangeInput': defineAsyncComponent(() => import('@/components/PropertyComponents/range.vue')),
    AddSubElementPopup,
    imageCarouselIcon,
    ResourceSelectionPopup,
    ColorPickerPopup,
    DeleteConfirmPopup,
    optionIcon,
    expandeIcon,
    NameElementPopup,
    textIcon,
    colorIcon,
    addIcon,
    deleteIcon,
    upperIcon,
    lowerIcon,
    copyIcon
  },
  props: {
    isComposition: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      type: Number,
      required: false,
      default: 0,
    },
    lengthIsIn: {
      type: Number,
      required: false,
      default: 0,
    },
    property: {
      type: [Object, null],
      required: true
    },
    element: {
      type: [Object, null],
      required: true
    },
    container: {
      type: [Object, null],
      required: true
    }
  },
  data() {
    return {
      expanded: false,
      showNameEdit: false,
      showDeleteConfirm: false,
      showAddSubElementPopup: false,
      shurtCutSelected: undefined,
      contextMenuShow: false,
      resolveShortcut: undefined,
      shortcutActionIndex: 0,
      addedElementShortCutAction: undefined,
      contextMenuComponent: {
        zIndex: 3,
        minWidth: 230,
        x: 0,
        y: 0
      },
    }
  },
  mounted: function() {
    if (this.element && this.element?.previewId == this.addedAction?.previewId) {
      this.addedElementShortCutAction = this.addedAction.addedElementShortCutAction;
      this.shortcutActionIndex = 0;
      this.shurtcutActionPromise();
    }
    if (this.container == null) {
      this.expanded = true;
    }
  },
  watch: {
    currentElementIndex: function() {
      if (this.expanded == true && this.currentElementIndex != this.element.previewId)
        this.expanded = false;
      else if (this.expanded == false && this.currentElementIndex == this.element.previewId)
        this.expanded = true;
    },
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'currentElementIndex',
      'addedAction',
      'copiedElement'
    ]),
    simpleElement() {
      return this.element.changeableProperty.filter((el) => el.type != "objectInput" && el.type != "arrayInput");
    },
    objectElement() {
      return this.element.changeableProperty.filter((el) => {
        if (el.type == "objectInput" && el.canBeAltered !== false) {
            return true;
        }
        else if (el.type == "arrayInput" && el.canBeAltered !== false) {
            return true;
        }
        return false;
      });
    },
    shurtCutProperty() {
      return this.element.changeableProperty.find((el) => el.name == this.shurtCutSelected?.name)
    },
    hasOption() {
      return this.canAddSubElement || this.element.CanBeRemove == true;
    },
    canExpand() {
      if (this.simpleElement.length == 0) return false;
      return true;
    },
    isExpanded() {
      return this.expanded;
    },
    isPrimary() {
      if (this.container == null) return true;
      return false;
    },
    canBeUpped() {
      if (!this.container || this.lengthIsIn == 0 || this.position == 0) return false;
      return true;
    },
    canBeLowered() {
      if (!this.container || this.lengthIsIn == 0 || this.position >= this.lengthIsIn - 1) return false;
      return true
    },
    canAddSubElement() {
      if (!this.element || this.element.CanAddElement === false) return false;
      return pageElements.some((el) => {
        if (el.type === this.element.objectType) {
          return el.subType.some(subType => {
            if (subType.is == "array") return true;
            if (this.element[subType.property] == null)
              return true;
          });
        }
        return false;
      });
    },
  },
  methods: {
    ...mapMutations(namespaceStore.THEME, {
      removeShurtcutAction: mutates.REMOVE_SHURTCUT_ACTION,
      setCopiedElement: mutates.SET_COPIED_ELEMENT
    }),
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY,
      'changeOrder': actions.UPDATE_ORDER_PROPERTY,
      'addElement': actions.ADD_ELEMENT,
      'actionRemoveElement': actions.REMOVE_PAGE_ELEMENT,
      'actionRemoveCompositionElement': actions.REMOVE_COMPOSITION_ELEMENT,
    }),
    copyElement() {
      this.setCopiedElement(this.element);
    },
    getStyleColor: function() {
      if (this.element.styleColor) {
        return {
          backgroundColor: this.element.styleColor
        }
      }
      return {};
    },
    shurtcutActionPromise() {
      if (this.shortcutActionIndex < this.addedElementShortCutAction.length) {
        new Promise((resolve) => {
          this.resolveShortcut = resolve;
          this.selectShurtCut(this.addedElementShortCutAction[this.shortcutActionIndex]);
        }).finally(() => {
          this.shurtcutActionPromise();
        });      
      }
      else {
        this.shortcutActionIndex = 0;
        this.addedElementShortCutAction = [];
        this.removeShurtcutAction();
      }
    },
    endShurtcut() {
      if (this.resolveShortcut) {
        this.shortcutActionIndex++;
        this.resolveShortcut();
      }
    },
    updateValue(value) {
      this.updateProperty({
        element: this.element,
        property: this.element.changeableProperty.find(el => el.name == this.shurtCutSelected.name),
        value: value
      });
      this.togglePopup();
    },
    selectRessource(resource) {
      this.updateProperty({
        element: this.element,
        property: this.element.changeableProperty.find(el => el.name == this.shurtCutSelected.name),
        value: resource.idSoft
      });
      this.togglePopup();
    },
    togglePopup() {
      this.shurtCutSelected = undefined;
      this.endShurtcut();
    },
    selectShurtCut(sh) {
      this.shurtCutSelected = sh;
      this.contextMenuShow = false;
    },
    changePosition(change) {
      this.contextMenuShow = false;
      this.changeOrder({element: this.container, index: this.position, move: change});
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    changeName(newName) {
      this.updateProperty({element: this.element, property: {name: "Name"}, value: newName});
      this.showNameEdit = false;
      this.endShurtcut();
    },
    confirmDelete() {
      this.showDeleteConfirm = false;
      this.$nextTick(() => {
        if (this.isComposition) {
          this.actionRemoveCompositionElement(this.element.previewId);
        }
        else {
          this.actionRemoveElement(this.element.previewId);
        }
      });
    },
    addSubElement(element) {
      this.addElement({
        target: element.property,
        toAdd: element.toAdd.constructor.fromObject({parent: this.element}),
        element: this.element
      });
      this.showAddSubElementPopup = false;
    },
    showContextMenu(event) {
      this.contextMenuShow = true;
      this.contextMenuComponent.x = event.x;
      this.contextMenuComponent.y = event.y;
    },
    getSubElement() {
      let elementsToadd = [];
      if (!this.element) return elementsToadd;
      for (const el of pageElements) {
        if (el.type === this.element.objectType) {
          pageElements.forEach(element => {
            const find = el.subType.find(subType => {
              if (element.type.match(subType.type) && element.ignoreOnStandardElement !== true) {
                if (subType.is == "array")
                  return true;
                else if (this.element[subType.property] == null)
                  return true;
              }
              return false;
            })
            if (find) {
              elementsToadd.push({toAdd: element, property: find.property});
            }
          });
          return elementsToadd;
        }
      }
      return [];
    },
  }
}
</script>

<style scoped>
.noBreak {
  white-space: nowrap;
}

.contextMenuLabel {
  width: 100%;
  margin-left: 10px;
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
}

.property-input:not(:last-child) {
  margin-bottom: 1rem;
}

.bordered {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.property-input.softHidden {
  gap: 0px;
}

.property-input.softHidden > .property-content > .property-content-simple {
  height: 0px;
  overflow: hidden;
}

.property-input.primary {
  background: none;
}

.property-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem 0;
  gap: 10px;
}

.property-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.add-sub-element-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: #3b82f6;
  transition: all 0.2s ease;
  padding: 0;
}

.add-sub-element-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.add-sub-element-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.delete-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  transition: all 0.2s ease;
  padding: 0;
}

.delete-button:hover {
  background-color: rgba(239, 68, 68, 0.3);
  border-color: #ef4444;
}

.delete-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.4);
}

.delete-icon {
  width: 1rem;
  height: 1rem;
  stroke-width: 2;
}

.property-label {
  font-size: 1.05rem;
  font-weight: 500;
  color: #e5e7eb;
}

.property-toggle-icon {
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  justify-content: center;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}

.property-toggle-icon:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.property-toggle-icon:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.property-toggle-icon.expanded {
  transform: rotate(90deg);
}

.property-content {
  /* margin-left: 1rem;
  padding-left: 0.5rem;
  border-left: 1px solid rgba(255, 255, 255, 0.1); */
}

.short-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #e5e7eb;
  transition: all 0.2s ease;
  padding: 0;
}
.short-icon {
  width: 1rem;
  height: 1rem;
}

.short-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.short-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}

.name-input {
  background: none;
  border: none;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  padding: 0;
  margin: 0;
  width: 100%;
}

/* .name-input:focus {
  outline: none;
} */
</style>

